import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import findIndex from 'lodash/findIndex';
import { TableActionType } from './TableActions.js';
import remove from 'lodash/remove';

function tableReducer(data, rowIdentifier) {
  var isAllSelected = function isAllSelected(selected) {
    return selected.length === data.length;
  };
  return function (state, action) {
    switch (action.type) {
      case TableActionType.SELECT_ALL:
        {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            isAllSelected: true,
            selected: _toConsumableArray(data)
          });
        }
      case TableActionType.DESELECT_ALL:
        {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            isAllSelected: false,
            selected: []
          });
        }
      case TableActionType.SELECT_FILTERED:
        {
          // @ts-ignore
          var newSelected = action.payload.map(function (p) {
            return p._original;
          });
          var selected = _toConsumableArray(state.selected);
          newSelected.map(function (item) {
            var index = findIndex(selected, function (o) {
              return o[rowIdentifier] === item[rowIdentifier];
            });
            if (index === -1) {
              selected.push(item);
            }
          });
          return _objectSpread2(_objectSpread2({}, state), {}, {
            selected: selected
          });
        }
      case TableActionType.DESELECT_FILTERED:
        {
          // @ts-ignore
          var deselected = action.payload.map(function (p) {
            return p._original;
          });
          var _selected = _toConsumableArray(state.selected);
          deselected.map(function (item) {
            remove(_selected, function (o) {
              return o[rowIdentifier] === item[rowIdentifier];
            });
          });
          return _objectSpread2(_objectSpread2({}, state), {}, {
            isAllSelected: false,
            selected: _selected
          });
        }
      case TableActionType.SELECT_ROW:
        {
          var _selected2 = [].concat(_toConsumableArray(state.selected), [action.payload]);
          return _objectSpread2(_objectSpread2({}, state), {}, {
            isAllSelected: isAllSelected(_selected2),
            selected: _selected2
          });
        }
      case TableActionType.DESELECT_ROW:
        {
          var _selected3 = _toConsumableArray(state.selected);
          for (var i = 0; i < _selected3.length; i++) {
            if (_selected3[i][rowIdentifier] === action.payload[rowIdentifier]) {
              _selected3.splice(i, 1);
              break;
            }
          }
          return _objectSpread2(_objectSpread2({}, state), {}, {
            isAllSelected: isAllSelected(_selected3),
            selected: _selected3
          });
        }
      case TableActionType.CLEAR_FILTERED:
        return _objectSpread2(_objectSpread2({}, state), {}, {
          filtered: []
        });
      case TableActionType.SET_FILTERED:
        return _objectSpread2(_objectSpread2({}, state), {}, {
          filtered: action.payload
        });
      case TableActionType.SET_SELECTED:
        return _objectSpread2(_objectSpread2({}, state), {}, {
          selected: _toConsumableArray(action.payload)
        });
      default:
        return state;
    }
  };
}

export default tableReducer;
